export default "__VITE_ASSET__B7FzW4pJ__"